import customFormData from "./custom-form-data";

const { general, clock, spots, scoring } = customFormData;

const indoorCustomFormData = {
    general: {
        ...general,
        fieldLength: {
            ...general.fieldLength,
            icon: "indoor-football"
        },
        fieldWidth: {
            ...general.fieldWidth,
            icon: "indoor-football"
        },
        endZoneLength: {
            ...general.endZoneLength,
            icon: "indoor-football"
        },
        promptToSkipKickoff: {
            disabled: true
        }
    },
    clock,
    spots: {
        ...spots,
        kickoff: {
            ...spots.kickoff,
            icon: "indoor-football"
        },
        KOTouchback: {
            ...spots.KOTouchback,
            icon: "indoor-football"
        },
        touchbackYardline: {
            ...spots.touchbackYardline,
            icon: "indoor-football"
        },
        safetyKO: {
            ...spots.safetyKO,
            icon: "indoor-football"
        },
        goalPostLocation: {
            ...spots.goalPostLocation,
            icon: "indoor-football"
        }
    },
    scoring: {
        ...scoring,
        dropKickFieldGoal: {
            title: "Drop Kick Field Goal",
            icon: "indoor-football"
        },
        dropKickPAT: {
            title: "Drop Kick PAT",
            icon: "indoor-football"
        },
        deuce: {
            title: "Deuce Score",
            icon: "indoor-football"
        }
    }
};

export default indoorCustomFormData;
